import { Component } from '@angular/core';

@Component({
  selector: 'app-customer-infomations',
  imports: [],
  templateUrl: './customer-infomations.component.html',
  styleUrl: './customer-infomations.component.scss'
})
export class CustomerInfomationsComponent {

}
